module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00028.e26b7687.jpg";